// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export default {
	page_title: "Booking",
	navbar_tab_1: "Flight",
	navbar_tab_2: "Extras",
	navbar_tab_3: "Coordinates",
	navbar_tab_4: "Payment",
	step: "STEP",
	you_accommodation: "Accommodation",
	adult: "adult",
	Adult: "Adult",
	adults: "adults",
	Adults: "Adults",
	child: "child",
	Child: "Child",
	children: "children",
	Children: "Children",
	age: "age",
	ages: "ages",
	mister: "Mr.",
	madam: "Ms",
	see_more: "See more",
	see_less: "Close",
	yes: "yes",
	no: "No",
	see_more_options: "See more options",
	more_infos: "More information",
	images_copyright: "Images are for example only",
	day_monday: "Monday",
	day_tuesday: "Tuesday",
	day_wednesday: "Wednesday",
	day_thursday: "Thursday",
	day_friday: "Friday",
	day_saturday: "Saturday",
	day_sunday: "Sunday",
	month_january: "January",
	month_february: "February",
	month_march: "March",
	month_april: "April",
	month_may: "May",
	month_june: "June",
	month_july: "July",
	month_august: "August",
	month_september: "September",
	month_october: "October",
	month_november: "November",
	month_december: "December",
	options_modify: "Customize",
	options_modify_panel: "Modify",
	options_panel_title_modify: "Modify the",
	options_panel_title_modify_la: "Modify the",
	options_panel_title_modify_for_1: "Modify the",
	options_panel_title_modify_for_2: "of",
	options_add: "Add",
	options_included: "Included",
	options_day: "day",
	options_days: "days",
	options_days_2: "days",
	options_from: "from",
	options_to: "to",
	options_validate_selection: "Validate my selection",
	validate_for_all_participants: "Validate my selection for all participants",
	options_removed: "removed from the package",
	options_error_sorry: "Sorry,",
	options_error_default_service: "this service",
	options_error_not_available: "is no longer available.",
	options_no_service_selected: "No service selected",
	options_no_skipass: "No ski pass selected",
	options_no_equipment: "No equipment selected",
	options_no_transport: "No transport  options selected",
	options_no_esf: "No skischool selected",
	options_no_insurance_skier: "No insurance selected",
	options_no_hotel_service: "No hotel options selected",
	options_15_cancellation: "Included: Free cancellation up to 15 days before the stay",
	options_45_cancellation: "Free 100% cancellation up to 40 days before arrival*",
	options_45_cancellation_under_sentence: "*More informations in our T&C",
	options_who_departs: "Participants",
	options_please_fill_participants: "Please enter the surnames, first name and ages of each person on the booking at the start of the holiday.",
	options_fill_names: "Please fill in the surnames, first name and ages of each person to benefit from the best prices.",
	options_participant: "Participant",
	options_years: "years",
	options_years_and_more: "more",
	options_age_at_start: "Age at the beginning of the holiday",
	options_first_name: "First name",
	options_lastname: "Surname",
	options_travelers_error_message: "Please fill in the surname, first name and ages of each person on the booking",
	options_prepare_your_voyage: "Personalise your holiday",
	options_select_your_insurances: "Select your insurance options",
	options_change_traveler_age: "Changing the age of the participant will reset all of his/her options.",
	options_change_traveler_age_confirmation: "The age of the following participants has been updated. All their options have been reset.",
	options_change_traveler_age_updated: "Participant information has been updated",
	options_I_understood: "I understand",
	options_skipass: "Ski pass",
	options_no_skipass_selected: "No ski pass selected",
	options_km_ski_slopes: "km of pistes",
	options_of_tracks: "pistes",
	options_remove_skipass_1: "If you remove this option from your package, an amount of",
	options_remove_skipass_2: "will be kept",
	options_no_queues: "The ski pass is delivered at the same time as the keys on arrival",
	options_skipass_blue_sentence: "Save time and money",
	options_equipment: "Ski equipment",
	options_select_level: "Select your range",
	criteria_997: "Eco",
	criteria_998: "Silver",
	criteria_999: "Golden",
	criteria_1000: "Platinium",
	criteria_1031: "Rookie",
	criteria_1030: "Champion",
	options_no_equipment_selected: "No equipment selected",
	options_enjoy_skiing_at_arrival_1: "Collect your equipment from the shop",
	options_enjoy_skiing_at_arrival_2: "which is located at",
	options_enjoy_skiing_at_arrival_3: "metres from your accommodation",
	options_helmet: "Helmet",
	options_shoes: "Ski boots",
	options_sticks: "Poles",
	options_equipment_blue_sentence: "Attain proximity and serenity",
	options_transport: "Transport",
	options_enjoy_skiing_at_arrival: "Benefit from skiing on arrival",
	options_distance_from_ski_shop_1: "The skishop",
	options_distance_from_ski_shop_2: "is located",
	options_distance_from_ski_shop_3: "from your accommodation",
	options_distance_from_ski_shop_4: "is located in the same building as your accommodation!,",
	options_add_transport: "Add transport",
	options_add_transport_for: "Add transport for",
	options_delete_transport: "Remove the transport",
	options_transport_first_date: "Outbound",
	options_transport_second_date: "Return",
	options_package_travelski: "Travelski package",
	options_train_plus_shuttle: "Train and transfer. No need to worry on your family ski holiday",
	options_no_transport_selected: "No transport  options selected",
	options_choose_a_go: "Choose your outbound",
	options_choose_a_return: "Choose your return",
	options_departure_station: "Departure point",
	options_arrival_station: "Arrival point",
	options_one_way_option: "Options",
	options_i_travel_in: "I travel in:",
	options_my_transfer: "My transfer",
	options_transport_summary_for: "Transport summary for",
	options_total_transport: "Total for transport",
	options_transit_time: "transfer time",
	options_estimated_time: "Estimated at",
	options_information: "Information",
	train: "train",
	criteria_1039: "1st class",
	criteria_1040: "2nd class",
	shuttle: "Shuttle",
	taxi: "Taxi",
	baggage_cabin: "Hand luggage",
	backpack: "Backpack",
	wifi: "Wifi",
	meal: "Meal",
	dinner: "Dinner",
	options_how_to_choose_title: "How do I choose a course suited to my skiing level?",
	options_ski_lesson: "Ski school",
	options_take_esf: "Select a course",
	options_course_on: "Course on",
	options_how_i_choose_lesson: "Choose a course suitable for your ski ability",
	options_beginner: "Beginner",
	options_piou_piou: "Piou-Piou",
	criteria_992: "Ourson",
	criteria_993: "Flocon",
	criteria_994: "1st star",
	criteria_995: "2 star",
	criteria_996: "3 star",
	options_no_course_selected: "No skischool selected",
	options_content_piou_piou: "I will be  trying skiing for the first time",
	options_content_ourson_title: "I have never skiied",
	options_content_ourson: "I want to command the snowplogh and make my first turns",
	options_content_flocon_title: "I have my level Ourson",
	options_content_flocon: "I feel like hitting the slopes and making big turns faster.",
	options_content_1_star_title: "I have my level flocun",
	options_content_1_star: "I can turn in snowplogh and take the ski lift on my own",
	options_content_2_star_title: "I have 1st star and can ski at ease on the green slopes",
	options_content_2_star: "I need to master parellel so I can ski the steeper slopes",
	options_content_3_star_title: "I have passed my 2 star",
	options_content_3_star: "I need top perfect my parellel turn and sliding so I can ski faster",
	options_content_adulte_beginner_title: "I do not ski",
	options_content_adulte_beginner: "I need to learn to stay upright, control my speed, make snowplogh turns and use the lifts",
	options_adults_beginner: "Adults - beginners",
	options_watch_video: "See the video",
	options_back_to_choices: "Return to the choices",
	options_age_group_1: "3 to 4 years old",
	options_age_group_2: "4 to 5 years old",
	options_age_group_3: "6 to 12 years old",
	options_age_group_4: "13 years and older (Adults)",
	options_see_menu: "See the menu",
	options_restaurant: "Restaurant & Board",
	options_catering_services: "Catering services to suit your tastes",
	options_facilitate_arrival: "Facilitate your arrival by booking your services",
	options_reserve_your_services: "Book your services",
	options_take_accommodation_services: "Select your hotel options",
	options_book_services: "Book your options",
	options_book_services_easy: "Prebook your options to ease  the arrival process",
	options_insurance: "Insurance",
	options_take_insurance: "Select the ski insurance",
	options_no_insurance_selected: "No insurance selected",
	options_insurance_advantages: "The advantages of ski insurance",
	options_per_pers: "person",
	options_breakage_theft: "Breakage and theft of personal or rental ski equipment",
	options_rescue_research: "Costs of search and rescue on the slopes",
	options_hospitalization: "Medical and hospital expenses (excluding social security)",
	options_repatriation: "Repatriation costs",
	options_interruption_stay: "Costs for interruption of the stay and refunds for unused services",
	options_snow_guarantee: "Snow guarantee",
	options_insurance_annulation: "Cancellation Insurance",
	options_per_booking: "Booking",
	options_cancellation: "Cancellation possible until the day before departure",
	options_reimbursement: "Refund by bank transfer for justified reasons",
	options_credit_note: "Covers cases excluded by credit cards",
	options_coverage_price: "Voucher valid for 12 months in case of unjustified reason",
	options_insurance_annulation_no: "I do not opt for the insurance",
	options_insurance_annulation_yes: "I opt for the insurance",
	options_insurance_slogan: "Covered during the stay",
	options_person: "person",
	options_free: "Free",
	commercial_discount: "Commercial discount",
	log_in_or_register: "Log-in or register to book",
	login_register: "Continue",
	email_not_valid: "Your email address is incorrect",
	user_info_mandatory_field: "Required field",
	user_info_invalid_phone: "Invalid format. Phone number must contain 10 numbers.",
	new_password_forgot_password: "Forgotten password",
	new_password_create_new_password: "Create your new password",
	new_password1: "New password",
	new_password2: "Confirm your new password",
	user_info_forgot_password: "Forgot my password",
	user_info_already_have_account: "Already have an account",
	user_info_enter_email: "Reset your password",
	user_info_email_sent: "We have sent a link to reset your password to",
	user_info_new_password: "Enter your new password",
	send: "Send",
	validate: "Validate",
	i_want_to_register: "Create my account",
	i_want_to_login: "Log-in",
	new_password_succes: "Your password has been reset successfully",
	login: "Have we met on the slopes before?",
	registration_or_login: "Create an account or log in to your account",
	save_booking: "Save your booking in your account and save time.",
	user_info_your_informations: "Your information",
	contacts_first_name: "1st name",
	contacts_last_name: "Surname",
	contacts_email: "email",
	contacts_other_email: "Sign in with another email",
	contacts_password1: "password",
	contacts_password2: "confirm your password",
	contacts_password_format: "Your passowrd must",
	contacts_password_format_lenght: "contain a minimum of 8 characters",
	contacts_password_format_lowercase: "contain at least 1 lowercase character",
	contacts_password_format_uppercase: "contain at least 1 uppercase character",
	contacts_password_format_number: "contain at least one number",
	contacts_password_format_character: "conatin at least one special character",
	contacts_passwords_dont_match: "The password does not match",
	contacts_email_is_not_valid: "The email is not valid",
	user_info_to_contact_you: "To contact you",
	contacts_address: "address",
	contacts_city: "town",
	contacts_country: "country",
	contacts_postal_code: "Postcode",
	contacts_phone_number: "Phone number",
	contacts_subscribe_newsletter: "I subscribe to the Travelski.com newsletter and take advantage of promotions, flash sales, and loyalty benefits!",
	opt_in_offers: "I agree to receive exclusive offers, holiday ideas and news from travelski",
	opt_in_quote: "I agree to be contacted if I save my search on the travelski website",
	opt_in_quote_payment: "I agree to be contacted in connection with the search I am about to save",
	personal_data_1: "Find out more about how travelski uses and protects your personal data,",
	personal_data_2: "Click here",
	personal_data_3: "You can unsubscribe free of charge at any time.",
	contacts_accept_conditions_1: "I have read and accept the",
	contacts_accept_conditions_2: "General Terms and Conditions",
	contacts_accept_conditions_3: "and I acknowledge that there is no right of withdrawal.",
	update_my_details: "Update my contact details",
	continue_with_these_contacts: "Continue with these details",
	save_registration: "Save",
	user_info_lihe_more_details: "More details",
	user_info_create_account: "Create an account",
	user_info_is_it_first_time: "Are you travelling with Travelski for the first time?",
	error_wrong_email: "The entered email address is invalid. Please check the details and try again.",
	payment_my_account: "My account",
	payment_choose_method: "Choose payment method",
	proceed_to_payment: "Proceed to payment",
	payment_by_credit_card: "Pay by card",
	flex_product: "Flex",
	payment_credit_card_payment_condition_1_desc_1: "With a Flex rate, the deposit is",
	payment_credit_card_payment_condition_1_desc_2: ", which corresponds to",
	payment_credit_card_payment_condition_1_desc_3: "of the total travel cost of your ski vacation.",
	payment_credit_card_payment_condition_1_desc_4: "The remaining amount of",
	payment_credit_card_payment_condition_1_desc_5: ", will be automatically debited on",
	payment_credit_card_payment_condition_1_notice_1: "30% deposit required at the point of booking, free modification until",
	payment_credit_card_payment_condition_1_notice_1_2: "(booking fees and insurance not included)",
	payment_credit_card_payment_condition_1_notice_2_2: ". Modifications of extras not including accommodations according",
	payment_credit_card_payment_condition_1_notice_2_3: "terms and conditions.",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_1: "With a Flex rate, the deposit is",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_2: ", which corresponds to",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_3: "of the total travel cost of your ski vacation.",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_4: "The remaining amount of",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_5: ", will be automatically debited on",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_1: "30% deposit required at the point of booking, free modification until",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_2: "(booking fees and insurance not included). Modifications of extras not including accommodations according",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_3: "terms and conditions.",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_1: "With a Flex rate, the deposit is",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_2: ", which corresponds to 100% of the total travel cost of your ski vacation.",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_3: "Free cancelation and modification until",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_4: "(booking fees and insurance not included). Modifications of extras not including accommodations according",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_5: "terms and conditions.",
	payment_credit_card_payment_condition_1_notice_PV_after_deposit_1: "Full payment at point of booking.",
	fix_product: "Fixed",
	payment_credit_card_payment_condition_2_desc_1: "You have chosen a Fixed offer. Today we are debiting",
	payment_credit_card_payment_condition_2_desc_2: ", which corresponds to 100% of the total travel cost of your ski vacation.",
	payment_credit_card_payment_condition_2_desc_3: "Non refundable. Modifications of extras not including accommodations according",
	payment_credit_card_payment_condition_2_desc_4: "terms and conditions.",
	payment_credit_card_payment_condition_2_notice_1: "Full payment at point of booking. Non refundable.",
	card_number: "Card number",
	credit_card_date: "MM/YY",
	cvc: "CVC",
	where_find_cvc: "Where you find the CVC number",
	cvc_popup_title: "Where do you find your verification code?",
	cvc_popup_desc: "For Mastercard and Visa, you will find the 3 digit code on the back of the card on the signature strip.",
	invalid_format: "Format not valid",
	invalid_card_detail: "The details of the card are not valid - please re-check the card details.",
	pay_with_ideal: "pay with iDeal",
	pay_with_bancontact: "pay with Bancontact",
	choose_bank: "Choose your bank",
	payment_error_popup_title: "Payment declined",
	payment_error_popup_text: "Sorry, but your payment has been declined. Please try again or contact us on",
	confirmation_error_popup_phone: "0800 260 5082",
	payment_error_popup_button: "OK",
	make_quote: "Your search",
	save_your_quote: "Save your search",
	devis_desc_1: "By saving search, you can find it in the section \"My customer account\" to proceed with the payment when you are ready to book.",
	devis_desc_4: "Please note:",
	devis_desc_5: "Check the availability of your stay at the time of booking",
	save: "Save",
	payment_status_check_payment: "Check payment",
	payment_status_confirm_payment: "Confirm payment",
	payment_status_check_availability: "Check availability",
	summary_accommodation_details: "Accommodation details",
	summary_package_total: "Your package",
	summary_thanks_to_pack_you_save: "With your Travelski package, you save",
	summary_fee: "Booking fees",
	summary_fee_WIYP: "Booking fees included",
	promocode: "Promotion code?",
	promocode_wrong: "The promotional code that you have used is not valid",
	promocode_first_name: "First name",
	promocode_last_name: "Surname",
	promocode_last_6_digits: "The 6 last digits on your card",
	promocode_date_of_birth: "Date of birth (dd/mm/yyyy)",
	promocode_date_of_birth_day: "Day",
	promocode_date_of_birth_month: "Month",
	promocode_date_of_birth_year: "Year",
	promocode_mandatory_field: "Required fields",
	promocode_invalid_format: "Incorrect format",
	green_banner: "By booking with Travelski, you’re assured the best price guarantee",
	summary_enter_code: "Enter your promotion code",
	summary_validate: "Validate",
	summary_total: "Total",
	summary_book: "Proceed to next step",
	confirmation_status_reservation_title: "Congratulations",
	confirmation_status_reservation_subtitle_1: "Your holiday begins in",
	confirmation_status_reservation_subtitle_2: "days",
	confirmation_reservation_1: "You will receive the confirmation of your booking and payment in a few minutes",
	confirmation_reservation_2: "As a reminder, we will take payment today of",
	confirmation_reservation_3: "corresponding to",
	confirmation_reservation_4: "% of the amount of your booking.",
	confirmation_reservation_5: "The balance of your booking is",
	confirmation_reservation_6: "which will be automatically taken",
	confirmation_reservation_7: ".",
	confirmation_reservation_8: "You can find all the details on your Travelski account. You can login",
	confirmation_reservation_9: "here",
	confirmation_reservation_10: ".",
	confirmation_by_phone: "Call an expert",
	confirmation_booking_100_percent_1: "You will receive within a few minutes the confirmation of your stay and that of your payment.",
	confirmation_booking_100_percent_2: "For your reminder, we proceed today with the debit of",
	confirmation_booking_100_percent_3: ", corresponding to 100% of the amount of your stay.",
	confirmation_booking_100_percent_4: "Find all this information on your Travelski account. You can connect",
	confirmation_booking_100_percent_5: "here",
	confirmation_booking_100_percent_6: ".",
	confirmation_status_reservation_title_already_paid: "Your stay has already been paid.",
	confirmation_status_quote_title: "Your search is saved",
	confirmation_status_quote_subtitle: "Remember to complete your reservation",
	confirmation_quote_1: "Travelski thanks you for your trust and is pleased to confirm that your search is saved.",
	confirmation_quote_2: "Reference:",
	confirmation_quote_3: "The search saved is not a booking or a reservation. Only when you pay a deposit or the full balance can we confirm the availability of the request.",
	confirmation_reserve_quick: "Book now!",
	go_back_to_booking: "Back to back my booking",
	confirmation_status_error_title: "An error has ocurred",
	confirmation_error_1: "We are sorry that your booking could not be confirmed. Do try again or contact us on",
	confirmation_other_payment_method: "0800 260 5082",
	confirmation_error_1_sentence: "Unfortunately, your stay reservation could not be processed",
	confirmation_unavailable_text: "Your requested accomodation is unfortunately no longer available. Please try again or contact us on",
	confirmation_error_text: "Sorry, but your payment has been declined. Please try again or contact us on",
	confirmation_error_phone: "0800 260 5082",
	confirmation_make_reservation_account_title: "My account",
	confirmation_make_reservation_account: "Log in to the \"My Account\" section to find your search and much more",
	confirmation_make_reservation_account_button: "Go to my account",
	confirmation_make_reservation_phone_title: "by phone",
	confirmation_make_reservation_phone_1: "Call one of our holiday advisors on",
	confirmation_make_reservation_phone_2: "0800 260 5082",
	confirmation_status_unavailable_title: "This accommodation is no longer available",
	confirmation_status_unavailable_subtitle: "We are sorry but the holiday you selected is no longer available.",
	confirmation_unavailable_1: "The holiday you selected is no longer available as it has just been booked by another customer.",
	confirmation_unavailable_2: "You have not been charged",
	confirmation_find_another: "Find another holiday",
	confirmation_find_another_same_title: "Keep the same accommodation",
	confirmation_find_another_same_1: "This is your preferred accommodation and you are flexible? Change the travel dates or select another room.",
	confirmation_find_another_same_button: "Return to the accommodation page",
	confirmation_find_another_other_title: "Stay in the same resort",
	confirmation_find_another_other_1: "This resort is popular, but we are confident you will love it.",
	confirmation_find_another_other_button: "Our opther options are",
	confirmation_find_another_search_title: "Search again",
	confirmation_find_another_search_1: "Despite our best efforts, you do not want to continue your serach at this resort.",
	confirmation_find_another_search_2: "No problem, Travelski offer options across 160 resorts.",
	confirmation_find_another_search_button: "Search again",
	confirmation_find_another_question_title: "Have a question? Have a problem?",
	confirmation_find_another_question_1: "0800 260 5082",
	confirmation_your_order: "Your order",
	confirmation_summary_details_button: "Details of my order",
	confirmation_access_account: "Go to my account",
	Transport_private: "Choose a private transfer for more comfort and flexibility",
	Transport_arrival: "On arrival, a private driver will be waiting for you to take your to your accommodation",
	Transport_return: "For the retiurn, a private driver will be waiting for me in front of your accommodation to take you back to the station",
	smile_and_pass: "Sm,ile&pass service: your pass ia available at the same time as you collect yopur keys",
	Transport_coaches: "Dedicated coaches with spacious seats and power sockets",
	Transport_meal: "Dinner and continental breakfast is included on the outbound train; lunch and afternoon tea is included on the return journey.",
	Transfer_private: "I have selected a private transfer for more comfort and flexibility",
	Transfer_bus: "I have selected a transfer by bus between the station and the resort",
	snowboard_seul_argent_name: "Snowboard only Silver",
	snowboard_seul_argent_description: "I require versatile equipment to progress my snowboarding",
	snowboard_seul_or_name: "Snowboard only Gold",
	snowboard_seul_or_description: "I am a competent rider and require high-performance equipment for the slopes and snowpark",
	pack_argent_snowboard_name: "Snowboard and boots Silver",
	pack_argent_snowboard_description: "I require versatile equipment to progress my snowboarding",
	pack_or_snowboard_name: "Snowboard and boots - Gold",
	pack_or_snowboard_description: "I am a competent rider and require high-performance equipment for the slopes and snowpark",
	skis_seuls_argent_name: "Skis and poles Silver",
	skis_seuls_argent_description: "I am a  beginner skier and I am looking for equipment suitable to enjoy green and blue slopes",
	skis_seuls_or_name: "Skis and poles - Gold",
	skis_seuls_or_description: "I am a competent skier and want equipment to allow me to ski the whole resort",
	skis_seuls_platine_name: "Skis and poles - Platinum",
	skis_seuls_platine_description: "I am a good skier and want advanced equipment   to maximise my experience on the mountain",
	pack_eco_name: "Skis, boots and poles - Eco",
	pack_eco_description: "I am looking for equipment  at a keen price",
	pack_argent_name: "Skis, boots and poles - Gold",
	pack_argent_description: "I am a  beginner skier and I am looking for equipment suitable to enjoy green and blue slopes",
	pack_or_name: "Skis, boots and poles - Gold",
	pack_or_description: "I am a competent skier and want equipment to allow me to ski the whole resort",
	pack_platine_name: "Skis, boots and poles - Platinum",
	pack_platine_description: "I am a good skier and want advanced equipment   to maximise my experience on the mountain",
	pack_mini_kid_ski_name: "Package for children ages 2- 5 (skis and boots)",
	pack_mini_kid_ski_description: "My child is just starting and wants light and flexible equipment so they learn easily",
	pack_espoir_skis_name: "Pack espoir for children ages 6-11 (skis, poles and boots)",
	pack_espoir_skis_description: "Ideal for children up to  3 star",
	pack_champion_skis_name: "Pack champion for children ages 6-11  (Skis, poles and boots)",
	pack_champion_skis_description: "My child is comfortable on the slopes and needs quality and reliable equipment to continue their progress",
	pack_espoir_snowboard_name: "Pack Mini Kid 2-5 ans (Skis + Chaussures)",
	pack_espoir_snowboard_description: "My child wants to start snowboarding with equipment ideal for young riders",
	pack_champion_snowboard_name: "Pack champion for children ages 6-11  (Snowboard and boots)",
	pack_champion_snowboard_description: "My child wants to start snowboarding with equipment ideal for young riders",
	global_insurance_conditions: "See the conditions of the insurance",
	contacts_incorrect_credentials: "Your credentials are incorrect",
	voir_le_detail_de_mon_trajet: "View the details of my journey",
	i_dont_want: "I do not want a",
	login_page_title: "Customer Account",
	accommodation_popup: "Accommodation details",
	liheDesc_included: "Available services",
	planner_what_is_included: "What is included?",
	productDesc_advantage: "The benefits of the stay",
	planner_prestationsAppartmentEquipment: "Apartment facilities:",
	planner_prestationsPrivateBathroom: "In your private bathroom:",
	planner_prestationsPrivateKitchen: "In your private kitchen:",
	planner_prestationsPrivateServices: "Available services",
	prestation_floorNumber: "Floor",

	criteria_354: "16 rooms",
	criteria_353: "15 rooms",
	criteria_352: "14 rooms",
	criteria_351: "13 rooms",
	criteria_350: "12 rooms",
	criteria_349: "11 rooms",
	criteria_348: "10 rooms",
	criteria_347: "9 rooms",
	criteria_346: "8 rooms",
	criteria_345: "7 rooms",
	criteria_344: "6 rooms",
	criteria_343: "5 rooms",
	criteria_342: "4 rooms",
	criteria_341: "3 rooms",
	criteria_340: "2 rooms",
	criteria_339: "1 room",
	criteria_338: "20 bedrooms",
	criteria_337: "19 bedrooms",
	criteria_336: "18 bedrooms",
	criteria_335: "17 bedrooms",
	criteria_334: "16 bedrooms",
	criteria_333: "15 bedrooms",
	criteria_332: "14 bedrooms",
	criteria_331: "13 bedrooms",
	criteria_330: "12 bedrooms",
	criteria_329: "11 bedrooms",
	criteria_328: "10 bedrooms",
	criteria_327: "9 bedrooms",
	criteria_326: "8 bedrooms",
	criteria_325: "7 bedrooms",
	criteria_324: "6 bedrooms",
	criteria_323: "5 bedrooms",
	criteria_322: "4 bedrooms",
	criteria_321: "3 bedrooms",
	criteria_320: "2 bedrooms",
	criteria_319: "1 bedroom",
	criteria_985: "5 double beds",
	criteria_982: "4 double beds",
	criteria_983: "3 double beds",
	criteria_762: "2 double beds",
	criteria_741: "1 double bed",
	criteria_987: "10 single beds",
	criteria_986: "9 single beds",
	criteria_988: "8 single beds",
	criteria_984: "7 single beds",
	criteria_767: "6 single beds",
	criteria_766: "5 single beds",
	criteria_765: "4 single beds",
	criteria_764: "3 single beds",
	criteria_763: "2 single beds",
	criteria_742: "1 single bed",
	criteria_769: "4 bunk beds",
	criteria_768: "2 bunk beds",
	criteria_743: "1 bunk bed",
	criteria_747: "Double sofa bed",
	criteria_771: "2 sofa beds",
	criteria_745: "1 sofa bed",
	criteria_744: "1 trundle bed",
	criteria_46: "Cot (on request)",
	criteria_746: "Baby care pack (on request)",
	criteria_29: "Sofa",
	criteria_773: "Balcony/Terrace",
	criteria_739: "Balconies",
	criteria_738: "Balcony",
	criteria_761: "Terrace",
	criteria_30: "Mezzanine",
	criteria_55: "Wifi available",
	criteria_27: "Wifi available",
	criteria_23: "Television",
	criteria_803: "Washing machine",
	criteria_47: "Dryer",
	criteria_799: "Maintenance kit",
	criteria_48: "Barbecue",
	criteria_25: "A/C",
	criteria_981: "Separate toilets",
	criteria_31: "Disabled access",
	criteria_705: "Equipped kitchen",
	criteria_757: "Separate kitchen",
	criteria_22: "Dishwasher",
	criteria_756: "Fridge",
	criteria_759: "Hob",
	criteria_750: "Oven",
	criteria_758: "Microwave",
	criteria_752: "Coffee machine",
	criteria_754: "Kettle",
	criteria_755: "Toaster",
	criteria_715: "Shower",
	criteria_714: "Bathtub",
	criteria_748: "Bedding",
	criteria_45: "Towels",
	criteria_801: "Beds made on arrival",
	criteria_51: "End of stay cleaning",
	criteria_76: "Private pool",
	criteria_75: "Indoor pool",
	criteria_74: "Outdoor pool",
	criteria_74_76: "Outdoor private pool",
	criteria_75_76: "Indoor private pool",
	criteria_71: "Spa",
	criteria_733: "Fitness room",
	criteria_69: "Hammam",
	criteria_70: "Sauna",
	criteria_732: "Hot tub",
	criteria_36: "Parking available",
	criteria_37: "Parking available",
	criteria_798: "Lift",
	criteria_979: "Kid’s Club",
	criteria_815: "100% - 18-35 YEARS OLD",
	criteria_52: "Pets allowed",
	criteria_800: "Ski locker",
	criteria_980: "Luggage storage",
	criteria_312: "Close to shops",
	criteria_807: "50 m from shops",
	criteria_808: "100 m from shops",
	criteria_306: "200 m from shops",
	criteria_307: "500 m from shops",
	criteria_308: "1 km from shops",
	criteria_309: "More than 1 km from shops",
	criteria_310: "More than 1 km from shops",
	criteria_311: "More than 1 km from shops",
	criteria_365: "Close to ESF meeting point",
	criteria_720: "50 m from ESF meeting point",
	criteria_721: "100 m from ESF meeting point",
	criteria_359: "200 m from ESF meeting point",
	criteria_360: "500 m from ESF meeting point",
	criteria_361: "1 km from ESF meeting point",
	criteria_362: "More than 1 km from ESF meeting point",
	criteria_363: "More than 1 km from ESF meeting point",
	criteria_364: "More than 1 km from ESF meeting point",
	criteria_305: "In the centre of the resort",
	criteria_718: "50 m from the centre",
	criteria_719: "100 m from the centre",
	criteria_299: "200 m from the centre",
	criteria_300: "500 m from the centre",
	criteria_301: "1 km from the centre",
	criteria_302: "More than 1 km from the center",
	criteria_303: "More than 1 km from the center",
	criteria_304: "More than 1 km from the center",
	criteria_291: "At the foot of the slopes",
	criteria_716: "50 m to the slopes",
	criteria_717: "100 m to the slopes",
	criteria_285: "200 m to the slopes",
	criteria_822: "300 m to the slopes",
	criteria_286: "500 m to the slopes",
	criteria_287: "1 km to the slopes",
	criteria_288: "More than 1 km from the slopes",
	criteria_289: "More than 1 km from the slopes",
	criteria_290: "More than 1 km from the slopes",
	criteria_60: "Catering service",
	criteria_61: "Catering service",
	criteria_62: "Catering service",
	criteria_63: "Catering service",
	criteria_64: "Catering service",
	criteria_65: "Catering service",
	criteria_67: "Catering service",
	criteria_66: "Catering service",
	criteria_700: "The skipass is delivered at the same time as the keys on arrival",
	food_image_criteria_1071: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 6 days_desktop.png",
	food_image_criteria_1071_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 6 days_mobile.png",
	food_image_criteria_1072: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 3 days Desktop.png",
	food_image_criteria_1072_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 3 days Mobile.png",
	food_image_criteria_1073: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 6 days Desktop.png",
	food_image_criteria_1073_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 6 days Mobile.png",
	food_image_criteria_1074: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only 3 days_desktop.png",
	food_image_criteria_1074_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only menu 3 days_mobile.png",
	food_image_criteria_1075: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only 6 days_desktop.png",
	food_image_criteria_1075_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only menu 6 days_mobile.png",
	food_image_criteria_1076: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 3 days_desktop.png",
	food_image_criteria_1076_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 3 days_mobile.png",
	food_image_criteria_1077: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 6 days_desktop.png",
	food_image_criteria_1077_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 6 days_mobile.png",
	food_image_criteria_1078: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 3 days_desktop.png",
	food_image_criteria_1078_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 3 days_mobile.png",
	session_expired: "Your session has expired, please refresh your page.",
	reload_page: "Refresh"
}
